import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthData } from 'src/app/shared/model/session';
import { TokenStorageService } from 'src/app/shared/service/token-storage.service';
import { MESSAGES } from '../constant/messages';
import { UserRole } from '../enum/user-role.enum';
import { UserStatus } from '../enum/user-status';
import { ToastService } from 'src/app/shared/service/toast.service';

@Injectable({ providedIn: 'root' })
export class AuthAdminGuard implements CanActivate {
  constructor(
    private tokenStorage: TokenStorageService,
    private router: Router,
    private toastService: ToastService
  ) {}

  canActivate(): boolean | UrlTree {
    const auth: AuthData | null = this.tokenStorage.getAuth();

    if (!auth?.token) {
      this.toastService.showMessages('error', [MESSAGES.AUTH.ADMIN_NO_ROLE]);
      return this.router.parseUrl('/admin/login');
    }

    if (auth.status !== UserStatus.AUTHENTICATED) {
      this.toastService.showMessages('error', [
        MESSAGES.AUTH.ADMIN_NOT_AUTHENTICATED,
      ]);
      return this.router.parseUrl('/admin/login');
    }

    if (!auth.user?.roles?.includes(UserRole.ADMINISTRADOR)) {
      this.toastService.showMessages('error', [MESSAGES.AUTH.ADMIN_NO_ROLE]);
      return this.router.parseUrl('/admin/login');
    }
    return true;
  }
}
